<div *ngIf="loading.isLoading;else loaded">
  <app-loading [loadingText]="loading.text"></app-loading>
</div>

<ng-template #loaded>


  <div *ngIf="loadError; else noErrors" class="load-error">
    <app-load-error [loadError]="loadError">
    </app-load-error>
  </div>

  <ng-template #noErrors>

    <div class="content-header">

      <div *ngIf="userCourse && !userCourse.isDeleted">

        <!-- <div class="ui container"> -->

        <div class="section-title">
          <div>{{ userCourse.code }} {{ userCourse.number }} {{ userCourse.name }} {{ userCourse.section }} {{ userCourse.semester }} {{ userCourse.year }} </div>
          <div class="subtitle">{{curriculumReview.name}} - {{curriculumReview.program}}
            <span *ngIf="curriculumReview.faculty">, {{curriculumReview.faculty}}</span>
          </div>

          <div class="subtitle archived" *ngIf="userCourse.isArchived">This course has been archived and cannot be
            modified.</div>

        </div>

        <div>
          Follow the steps below to map your course. <strong>Please submit once you have finished all the
            steps.</strong>
        </div>

        <div class="steps">

          <div [ngClass]="{
                'ui': 1,            
                'three': userSteps.length == 3,
                'four': userSteps.length == 4,
                'five': userSteps.length == 5,
                'six': userSteps.length == 6,
                'seven': userSteps.length == 7,
                'column': 1,
                'grid': 1,
                'stackable': 1
              }">

            <div class="column" *ngFor="let userStep of userSteps; let i = index">
              <a [routerLink]="['/user/courses', userCourse.id, userStep.name]"
                [ngClass]="{'active': currentStep == userStep.name}">
                <div class="ui  circular label">{{ i+1 }}</div>
                <div class="step-title"> {{userStep.title}}</div>
              </a>

            </div>

          </div>

        </div>

        <!-- </div> -->


        <div *ngIf="userCourse">

          <div class="ui segment">

            <div class="content">
              <app-user-step-assessment class="user-step" *ngIf="currentStep == 'assessment'" [courseId]="userCourse.id"
                [review]="curriculumReview"></app-user-step-assessment>

              <app-user-step-tla *ngIf="currentStep == 'tla'" [courseId]="userCourse.id" [review]="curriculumReview">
              </app-user-step-tla>

              <app-user-step-course-outcome class="user-step" *ngIf="currentStep == 'outcome'"
                [courseId]="userCourse.id" [review]="curriculumReview"></app-user-step-course-outcome>

              <app-user-step-course-outcome-details class="user-step"
                *ngIf="currentStep == 'outcome-detail' && assessmentFormat && tlaFormat" [courseId]="userCourse.id"
                [review]="curriculumReview" [assessmentFormat]="assessmentFormat" [tlaFormat]="tlaFormat"
                (disableNavigation)="disableNavigation($event)"></app-user-step-course-outcome-details>


              <app-user-step-mapping class="user-step" *ngIf="currentStep == 'mapping'" [courseId]="userCourse.id"
                [review]="curriculumReview" (disableNavigation)="disableNavigation($event)"></app-user-step-mapping>

              <app-user-step-course-question class="user-step" *ngIf="currentStep == 'question'"
                [courseId]="userCourse.id" [review]="curriculumReview" (disableNavigation)="disableNavigation($event)">
              </app-user-step-course-question>

              <app-user-step-summary class="user-step" *ngIf="currentStep == 'summary' && assessmentFormat && tlaFormat"
                [courseId]="userCourse.id" [userCourse]="userCourse" [review]="curriculumReview"
                [assessmentFormat]="assessmentFormat" [tlaFormat]="tlaFormat" [programOutcomes]="programOutcomes"
                [programOutcomeCategories]="programOutcomeCategories" [userSteps]="userSteps"
                (courseSubmitted)="courseSubmitted()"></app-user-step-summary>

            </div>


            <div class="nav-button-area" *ngIf="userCourse.status != 'Submitted' && !this.curriculumReview.isArchived">

              <button *ngIf="currentStepIndex != 0" class="ui left labeled icon button prev-step-button tiny"
                (click)="activatePrev()" [disabled]="isNavigationDisabled">
                <i class="left arrow icon"></i>Previous - {{ userSteps[currentStepIndex-1].title }}</button>
              <button *ngIf="currentStepIndex != userSteps.length -1"
                class="ui right labeled icon  button next-step-button tiny" (click)="activateNext()"
                [disabled]="isNavigationDisabled">
                <i class="right arrow icon"></i>Next - {{ userSteps[currentStepIndex+1].title }}</button>
            </div>


          </div>

        </div>


      </div>


      <div *ngIf="userCourse && userCourse.isDeleted">

        <div class="ui container">
          <div class="ui message error">
            This course has been deleted by the administrator.
          </div>
        </div>

      </div>


    </div>





  </ng-template>


</ng-template>